function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "video-container",
  ref: "videoContainer"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  key: 1,
  class: "no-video-placeholder"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createBlock(_component_b_modal, {
    ref: "video-side-modal",
    id: "video-side-modal",
    title: "Video návod",
    size: "xl",
    "no-fade": "",
    "no-footer": "",
    lazy: "",
    "no-close-on-esc": "",
    "no-close-on-backdrop": "",
    "body-class": "p-0",
    modelValue: $data.modal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.modal = $event;
    }),
    onShow: $options.onModalShow,
    onHidden: $options.onModalHidden
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [$props.videoSideModalUrl ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        class: "video-iframe",
        src: $props.videoSideModalUrl,
        title: "YouTube video player",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        allowfullscreen: ""
      }, null, 8 /* PROPS */, _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toConsumableArray(_cache[1] || (_cache[1] = [_createElementVNode("p", null, "Načítání videa...", -1 /* CACHED */)]))))], 512 /* NEED_PATCH */)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onShow", "onHidden"]);
}